import { ApplicationYearMakeModelFilter, CompatibleWithApplicationPartModel } from "@dana/Handlers/CompatibleWithApplicationHandler";
import CompatibleWithApplicationState from "@dana/Store/Data/CompatibleWithApplication/CompatibleWithApplicationState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialCounterState: CompatibleWithApplicationState = {
    parts: undefined, // Replace with actual type if available
    isLoading: false,
    pagination: null,
    clearSearch: false,
};

const compatibleWithApplicationImmerReducer = createTypedReducerWithImmer(initialCounterState, {
    "CompatibleWithApplicationParts/StartLoading": (draft: Draft<CompatibleWithApplicationState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },

    "CompatibleWithApplicationParts/LoadComplete": (draft: Draft<CompatibleWithApplicationState>, action: { parts: CompatibleWithApplicationPartModel[], pagination: PaginationModel,filter:ApplicationYearMakeModelFilter }) => {
        draft.parts = action.parts;
        draft.pagination = action.pagination;
        draft.filter = action.filter;
        draft.isLoading = true;
    },
    "CompatibleWithApplication/EndLoading": (draft: Draft<CompatibleWithApplicationState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "CompatibleWithApplicationParts/ClearSearch": (draft: Draft<CompatibleWithApplicationState>, action: { clearSearch: boolean }) => {
        draft.clearSearch = action.clearSearch;
    },
});

(reducers as any).compatibleWithApplicationState = compatibleWithApplicationImmerReducer;

type CompatibleWithApplicationReducers = {
    compatibleWithApplicationState: typeof compatibleWithApplicationImmerReducer;
};

export type CompatibleWithApplicationActions = Parameters<CompatibleWithApplicationReducers[keyof CompatibleWithApplicationReducers]>[1] | AnyAction;


